import { Col, Input, Label } from "reactstrap";
import { InstagramAnimated, WhatIsYourFavoriteSocialMedia } from "../../../../Constant";
import { ANIMATED_SOCIAL } from "../../../../Data/FormControl/CheckboxAndRadio";
import { H6 } from "../../../../AbstractElements";
import { Fragment } from "react";

export const AnimatedCheckbox = () => {
  return (
    <Col sm="6">
      <div className="card-wrapper border rounded-3 checkbox-checked">
        <H6 className="sub-title">{WhatIsYourFavoriteSocialMedia}</H6>
        <Label className="d-block" htmlFor="chk-ani" check></Label>
        <Input className="checkbox_animated" id="chk-ani" type="checkbox" />
        {InstagramAnimated}
        {ANIMATED_SOCIAL.map(({ id, text, defaultChecked }, index) => (
          <Fragment key={index}>
            <Label className="d-block" htmlFor={id} check></Label>
            <Input className="checkbox_animated" id={id} type="checkbox" defaultChecked={defaultChecked} />
            {text}
          </Fragment>
        ))}
      </div>
    </Col>
  );
};
